import { BehaviorSubject, combineLatest as observableCombineLatest } from 'rxjs';
import { combineLatest, filter, map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../base/reducers';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { TenantService } from '../../shared/services/tenant.service';
var PageRoutingService = /** @class */ (function () {
    function PageRoutingService(translate, router, titleSvc, tenantSvc, store) {
        var _this = this;
        this.translate = translate;
        this.router = router;
        this.titleSvc = titleSvc;
        this.tenantSvc = tenantSvc;
        this.store = store;
        this.pageSubject = new BehaviorSubject(null);
        this.pageTrailSubject = new BehaviorSubject([]);
        this.breadcrumbsSubject = new BehaviorSubject(true);
        this.simplifiedHeaderSubject = new BehaviorSubject(false);
        observableCombineLatest(store.pipe(select(fromBase.getCurrentPage)), store.pipe(select(fromBase.getAppName))).pipe(map(function (_a) {
            var page = _a[0], appName = _a[1];
            if (appName) {
                page && page.name
                    ? _this.titleSvc.setTitle(page.name + " - " + appName + " - Webshop")
                    : _this.titleSvc.setTitle(appName + " - Webshop");
            }
            else {
                _this.titleSvc.setTitle('Webshop');
            }
            return page;
        }))
            .subscribe(this.pageSubject);
        store.pipe(select(fromBase.getPageTrail), map(function (trail) { return trail.map(function (page) { return ({
            name: page && page.name,
            slug: page && page.slug
        }); }); }))
            .subscribe(this.pageTrailSubject);
    }
    Object.defineProperty(PageRoutingService.prototype, "page$", {
        get: function () {
            return this.pageSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    PageRoutingService.prototype.pageUntil$ = function (predicate) {
        return this.pageSubject.asObservable().pipe(takeUntil(this.router.events.pipe(filter(function (ev) { return ev instanceof NavigationStart; }), map(function (ev) { return ev.url; }), filter(predicate), take(1))));
    };
    Object.defineProperty(PageRoutingService.prototype, "breadCrumbs$", {
        get: function () {
            return this.pageTrailSubject.asObservable().pipe(combineLatest(this.translate.stream(['header.home'])), map(function (result) {
                if (result[0].find(function (item) { return item.slug === 'home'; }))
                    return result[0];
                else
                    return [
                        { name: result[1]['header.home'], slug: '/home' }
                    ].concat(result[0]);
            }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageRoutingService.prototype, "breadcrumbsStatus$", {
        get: function () {
            return this.breadcrumbsSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageRoutingService.prototype, "breadcrumbsStatus", {
        set: function (value) {
            this.breadcrumbsSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageRoutingService.prototype, "simplifiedHeaderStatus$", {
        get: function () {
            return this.simplifiedHeaderSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageRoutingService.prototype, "simplifiedHeaderStatus", {
        set: function (value) {
            this.simplifiedHeaderSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageRoutingService.prototype, "tenantWantsBreadcrumbs$", {
        get: function () {
            // SK TODO: make this a tenant setting together with bakkie
            var wantsCrumbs = new BehaviorSubject(true);
            this.tenantSvc.tenantName$.subscribe(function (tenantName) {
                if (tenantName && tenantName.toLowerCase() === "bolsius") {
                    wantsCrumbs = new BehaviorSubject(false);
                }
            });
            return wantsCrumbs.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    return PageRoutingService;
}());
export { PageRoutingService };
